export default __webpack_public_path__ + "static/media/bar.68112b19.svg";